import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminSidenavComponent} from '../../../shared/layout/side-navbar/admin-sidenav.component';

// IMPORT SPECIFIQUES A L'ATTESTATION
import {HousingCertificateComponent} from './housing-certificate.component';
import {HcComponentFormComponent } from './hc-component-form/hc-component-form.component';
import {HcComponentConfirmComponent} from './hc-component-confirm/hc-component-confirm.component';
import { HcComponentPaymentComponent } from './hc-component-payment/hc-component-payment.component';
import { HcHomeComponent } from './hc-home/hc-home.component';
import { HcComponentPostPaymentComponent } from './hc-component-post-payment/hc-component-post-payment.component';

// Modules
//import { PdfViewerModule} from 'ng2-pdf-viewer';
import { AppSharedModule } from 'src/app/appShared.module';

export const HousingCertificateRouteList: Routes = [
  {path:'',
  component:AdminSidenavComponent,
  children : [
    {path: 'start',component: HousingCertificateComponent, data: {page: 'start'}},
    {path: 'informations',component: HousingCertificateComponent, data: {page: 'informations'}},
    {path: 'confirmation',component: HousingCertificateComponent, data: {page: 'confirmation'}},
    {path: 'payment',component: HousingCertificateComponent, data: {page: 'payment'}},
    {path: 'post-payment',component: HousingCertificateComponent, data: {page: 'post-payment'}},
    {path: 'pending',component: HousingCertificateComponent, data: {page: 'Pending-refund'}},
    {path: 'pending-document',component: HousingCertificateComponent, data: {page: 'Pending-document'}},
    {path: 'refunded',component: HousingCertificateComponent, data: {page: 'refunded'}},
    {path: 'not-refunded',component: HousingCertificateComponent, data: {page: 'not-refunded'}},
    {path: 'expired',component: HousingCertificateComponent, data: {page: 'expired'}},
    {path: '',redirectTo:'/housing-certificate/start',pathMatch: 'full'},
  ]},
  {path: '**',redirectTo:'/housing-certificate/start',pathMatch: 'full'},
];

@NgModule({
    imports: [
        RouterModule.forChild(HousingCertificateRouteList),
        AppSharedModule,
        //PdfViewerModule,
        HcComponentFormComponent,
        HcComponentConfirmComponent,
        HcHomeComponent,
        HcComponentPaymentComponent,
        HcComponentPostPaymentComponent
    ],
    exports: [
        HcComponentFormComponent,
        HcHomeComponent,
        HcComponentConfirmComponent,
        HcComponentPaymentComponent,
        HcComponentPostPaymentComponent,
    ]
})
export class HousingCertificateRoutingModule {}


